import { Component, inject } from '@angular/core';
import { LsButtonComponent } from '@axess/ng-limestone';
import { AccessibilitySidebarFacade } from '@components/accessibility-sidebar/data-access/services/accessibility-sidebar-facade';
import { TranslateModule } from '@ngx-translate/core';
import { HideTranslationPipe } from '@shared/pipes/hide-translation/hide-translation.pipe';
import { AddAttributes } from '@ui/directives/add-attributes';

@Component({
  selector: 'app-accessibility-sidebar',
  templateUrl: './accessibility-sidebar.html',
  styleUrls: ['./accessibility-sidebar.scss'],
  standalone: true,
  imports: [TranslateModule, HideTranslationPipe, AddAttributes, LsButtonComponent],
  providers: [AccessibilitySidebarFacade]
})
export class AccessibilitySidebar {
  readonly #AccessibilitySidebarFacade = inject(AccessibilitySidebarFacade);

  protected accessibilitySidebarState = this.#AccessibilitySidebarFacade.state;

  protected toggleIsOpen($event: MouseEvent | KeyboardEvent) {
    $event.stopPropagation();
    $event.preventDefault();

    this.#AccessibilitySidebarFacade.toggleIsOpen();
  }

  protected toggleHighContrast($event: MouseEvent | KeyboardEvent) {
    $event.stopPropagation();
    $event.preventDefault();

    this.#AccessibilitySidebarFacade.toggleHighContrast();
  }

  protected increaseFontSize($event: MouseEvent, currentFontSizePercentage: number) {
    $event.stopPropagation();

    this.#AccessibilitySidebarFacade.increaseFontSize(currentFontSizePercentage);
  }

  protected decreaseFontSize($event: MouseEvent, currentFontSizePercentage: number) {
    $event.stopPropagation();

    this.#AccessibilitySidebarFacade.decreaseFontSize(currentFontSizePercentage);
  }

  protected resetState($event: MouseEvent | KeyboardEvent, areDefaultSettingsChanged: boolean) {
    $event.stopPropagation();
    $event.preventDefault();

    if (!areDefaultSettingsChanged) {
      return;
    }

    this.#AccessibilitySidebarFacade.resetState();
  }
}
